import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AdminRegistration from "../../components/pageManager/AdminRegistration";

const AdminRegistrationPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AdminRegistration />
                </div>
            </div>
        </div>
    );
};

export default AdminRegistrationPage;
